export const iconFontAwesomeNaturePersonHiking = (
	<i className="fa-solid fa-person-hiking"></i>
);
